.cue-cards-container {
    width: 300px;
    margin-left: auto;
}
